import { ModerationItemType } from '@fiverr-private/bianka_js/protobuf/bianka/enums/moderation/moderation_item_type';
import { ENTITY_TYPE } from '../../constants';
import { VIOLATION_LOCATION_VALUES } from '../../components/IssueForm/steps/constants';
import { CJReportedComponentItemType } from './types';

enum CJ_REPORTED_COMPONENT_ITEM_TYPE {
    VIDEO_AUDIO = 'video/audio',
    IMAGE = 'image',
    TEXT = 'text',
}

// TODO: Update this after bianka_js is updated
type ENTITY_TYPE_WITHOUT_ATTACHMENT = Exclude<ENTITY_TYPE, ENTITY_TYPE.ATTACHMENT>;

const VIOLATION_LOCATION_TO_CJ_REPORTED_COMPONENT: Record<VIOLATION_LOCATION_VALUES, CJReportedComponentItemType> = {
    [VIOLATION_LOCATION_VALUES.VIDEO_AUDIO]: CJ_REPORTED_COMPONENT_ITEM_TYPE.VIDEO_AUDIO,
    [VIOLATION_LOCATION_VALUES.IMAGE]: CJ_REPORTED_COMPONENT_ITEM_TYPE.IMAGE,
    [VIOLATION_LOCATION_VALUES.TEXT]: CJ_REPORTED_COMPONENT_ITEM_TYPE.TEXT,
};

const ENTITY_TYPE_TO_MODERATION_ITEM_TYPE: Record<ENTITY_TYPE_WITHOUT_ATTACHMENT, ModerationItemType> = {
    [ENTITY_TYPE.GIG]: ModerationItemType.GIG,
    [ENTITY_TYPE.MESSAGE]: ModerationItemType.MESSAGE,
    [ENTITY_TYPE.VIDEO_CALL]: ModerationItemType.VIDEO_CALL,
    [ENTITY_TYPE.BRIEF]: ModerationItemType.BRIEF,
    [ENTITY_TYPE.DEFAULT]: ModerationItemType.UNSPECIFIED,
};

const PAGE_NAMES: Record<ENTITY_TYPE_WITHOUT_ATTACHMENT, string> = {
    [ENTITY_TYPE.BRIEF]: 'brief_card_item_card',
    [ENTITY_TYPE.GIG]: 'gig_card_item_card',
    [ENTITY_TYPE.MESSAGE]: 'message_card_item_card',
    [ENTITY_TYPE.VIDEO_CALL]: 'video_call_card_item_card',
    [ENTITY_TYPE.DEFAULT]: '',
};

export const getMappedModerationItemType = (type: ENTITY_TYPE): ModerationItemType =>
    ENTITY_TYPE_TO_MODERATION_ITEM_TYPE[type] ?? ModerationItemType.UNSPECIFIED;

export const getMappedPageName = (type: ENTITY_TYPE): string => PAGE_NAMES[type] ?? '';

export const formatReportedComponents = (issueLocations?: VIOLATION_LOCATION_VALUES[]): string | undefined => {
    if (!Array.isArray(issueLocations) || issueLocations.length === 0) {
        return;
    }

    const mappedComponents: CJReportedComponentItemType[] = issueLocations.map(
        (location) => VIOLATION_LOCATION_TO_CJ_REPORTED_COMPONENT[location]
    );

    return JSON.stringify(mappedComponents);
};
